import { render } from "./DashboardModalDialog.vue?vue&type=template&id=526da2d4&scoped=true"
import script from "./DashboardModalDialog.vue?vue&type=script&lang=js"
export * from "./DashboardModalDialog.vue?vue&type=script&lang=js"

import "./DashboardModalDialog.vue?vue&type=style&index=0&id=526da2d4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526da2d4"]])

export default __exports__